<template>
  <div class>
    <div class="row mt-4">
      <div class="flex md12">
        <div class="row">
          <div class="flex md1">
            <va-button color="info" @click="createNew()" icon="fa fa-plus" />
          </div>
          <div class="flex md11">
            <h4 class="fullwidth" style="position: relative; top: 0.5em">
              Ajouter une période d'adhésion tierce
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="flex md12" v-if="adhesionsList.length < 1">
            <p class="text--secondary">Aucune adhésion</p>
          </div>
        </div>
        <div class="row">
          <div
            class="row mt-1 clickable container-comments"
            :style="'max-height: 100%'"
          >
            <template v-for="adhesions in adhesionsList">
              <div
                class="row px-2 pt-2 fullwidth"
                @click="openAdhesion(adhesions)"
              >
                <div class="flex md2">
                  <div class="row row-inside">
                    <div class="flex md1">
                      <va-icon
                        name="fa fa-circle"
                        :color="adhesions.isactive"
                        size="8px"
                      />
                    </div>
                    <div class="flex md11">
                      <p>
                        Du {{ adhesions.date_adhesion }} au
                        {{ adhesions.date_fin }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="flex md2 test pb-2">
                  <va-chip class="fullwidth-badge" :color="adhesions.color">{{
                    adhesions.nom_court
                  }}</va-chip>
                </div>
                <div class="flex md1 test">
                  <p>{{ cotisationText(adhesions.montant) }}</p>
                  <p class="text--secondary">
                    {{ paiementStatuts(adhesions) }}
                  </p>
                </div>
                <div class="flex md3 test px-3">
                  <p>
                    Créé le {{ adhesions.date_creation }} par
                    {{ adhesions.usernameverif }}
                  </p>
                </div>
                <div class="flex md3 test">
                  <p>{{ adhesions.commentaires }}</p>
                </div>
                <div class="flex md1 test">
                  <va-icon
                    name="fa fa-id-card-o"
                    :color="adhesions.bulletinColor"
                  ></va-icon>
                </div>
                <div
                  class="flex md12"
                  v-show="adhesions.selectPaiement.id !== 1"
                >
                  <p>
                    Paiement par
                    <b>{{ adhesions.selectPaiement.description }}</b>
                  </p>
                </div>

                <div class="flex md12 row-separator" />
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <autres-adhesions-manager
      v-model="openManager"
      :idadhesion="idadhesion"
      :adhesiontype="adhesiontype"
      :identreprise="identreprise"
      v-on:ok="updateAdhesion(identreprise)"
    ></autres-adhesions-manager>
  </div>
</template>

<script>
import axios from "axios";
import { cloneDeep, find, findIndex } from "lodash";
import AutresAdhesionsManager from "./AutresAdhesionsManager";
import moment from "moment";

export default {
  name: "autresAdhesionsList",
  props: ["identreprise"],
  components: {
    AutresAdhesionsManager,
  },
  data() {
    return {
      //TODO a preciser
      isAdmin:
        this.$store.getters.user.droits &&
        this.$store.getters.user.droits === "ADMIN",
      openManager: false,
      adhesiontype: null,
      idadhesion: null,
      adhesionsList: [],
      defaultPrice: 180,
      paiementOptions: [
        {
          id: 2,
          description: "Chèque - 1 versement annuel",
        },
        {
          id: 3,
          description: "Virement - 1 versement annuel",
        },
        {
          id: 4,
          description: "Espèces - 1 versement annuel",
        },
        {
          id: 5,
          description: "Prélèvement - 1 prélèvement annuel",
        },
        {
          id: 6,
          description: "Prélèvements - 4 prélèvements annuel",
        },
        {
          id: 7,
          description: "Adhésion offerte",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    cotisationText(cotisation) {
      if (cotisation === 0 || cotisation === "0") {
        return "Cotisation offerte";
      } else if (cotisation) {
        return "Cotisation " + cotisation + "€";
      } else {
        return "-";
      }
    },
    paiementStatuts(adhesion) {
      if (!adhesion.montant) {
        return "";
      } else {
        return adhesion.date_paiement
          ? "Payé le " +
              moment(adhesion.date_paiement, "YYYY-MM-DD").format("DD/MM/YYYY")
          : "En attente de paiement";
      }
    },
    openAdhesion(adhesion) {
      this.idadhesion = adhesion.idautres_adhesion;
      this.idadhesions_type = adhesion.idadhesions_type;
      this.openManager = true;
    },
    createNew() {
      //TODO
      this.idadhesion = null;
      this.idadhesions_type = null;
      this.openManager = true;
    },
    updateAdhesion(identreprise) {
      // todo force change if an adhesion have been open, not clean
      this.$emit("adhesionschange", true);
      this.loadAdhesion(identreprise);
    },
    async loadAdhesion(identreprise) {
      try {
        let rlist = await axios.get("/api/autres-adhesions/list", {
          params: {
            identreprise: identreprise,
          },
        });

        this.adhesionsList = rlist.data;
        this.adhesionsList.forEach((element) => {
          if (element.idadhesions_type === 1) {
            element.color = "danger";
          } else if (element.idadhesions_type === 2) {
            element.color = "info";
          } else if (element.idadhesions_type === 3) {
            element.color = "warning";
          } else {
            element.color = "dark";
          }
          element.isactive = moment(element.date_fin, "YYYY-MM-DD").isAfter(
            moment()
          )
            ? "success"
            : "warning";
          element.date_creation = moment(element.date_creation).format(
            "DD/MM/YYYY"
          );
          element.bulletinColor = element.pdfdisponible ? "success" : "info";
          element.date_adhesion = moment(
            element.date_adhesion,
            "YYYY-MM-DD"
          ).format("DD/MM/YYYY");
          element.date_fin = moment(element.date_fin, "YYYY-MM-DD").format(
            "DD/MM/YYYY"
          );

          if (element.idpaiement_type === 1 || !element.idpaiement) {
            element.selectPaiement = {
              id: 1,
              description: "inconnu",
            };
          } else {
            element.selectPaiement = find(this.paiementOptions, [
              "id",
              element.idpaiement_type,
            ]);
          }
        });
        this.idadhesion = null;
        this.idadhesions_type = null;

        console.log(this.adhesionsList);
      } catch (error) {
        console.log(error);
      }
    },

    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
  watch: {
    identreprise(newid) {
      if (newid) {
        this.loadAdhesion(newid);
      } else {
      }
    },
  },
};
</script>

<style lang="scss">
.fullwidth-badge {
  width: 80%;
}
.offset-delete {
  position: relative;
  top: -1em;
}

.container-comments {
  overflow: auto;
  overflow-x: hidden;
}
.clickable {
  display: flex;
  :hover {
    background-color: $light-gray3;
    cursor: pointer;
  }
}
.fullwidth {
  width: 95%;
}
.row-separator {
  width: 100%;
  border-color: #babfc2;
  border-width: 1px;
  border-bottom-style: solid;
}
.warning--text {
  color: red;
}
</style>
